import styled from "@emotion/styled";
import colors from "src/styles/variables.scss";

export const Layout = styled.div`
  background-color: ${colors.blackBackground};
  height: 100%;
  width: 100%;
  /* position: fixed; */
`;
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(12, 1fr);
  grid-gap: 0.8rem;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  .header {
    grid-column: 1/13;
    grid-row: 1/2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 6%;
    margin-top: 12%;
    .headerRow {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      .close-btn {
        margin-left: 5%;
        color: ${colors.milkyWhite};
        font-size: 20px;
        background: none;
        border: none;
        &:hover,
        &:focus {
          background: none;
        }
      }
      .headerTitle {
        height: 2.16rem;
        font-family: Arial, "sans-serif";
        font-size: 1.6rem;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: ${colors.milkyWhite};
        margin-left: 4%;
        span {
          height: 100%;
          width: 100%;
          position: relative;
          .manageMetricTooltipGroup {
            margin-top: 5%;
            position: absolute;
            /* Position the tooltip */
            z-index: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .arrowUP {
              position: absolute;
              top: -9%;
              width: 0;
              height: 0;
              border-left: 0.5rem solid transparent;
              border-right: 0.5rem solid transparent;
              border-bottom: 0.5rem solid #ffed82;
              margin-left: 15%;
            }

            .manageMetricTooltip {
              width: 16.2rem;
              height: 5rem;
              background-color: ${colors.paleYellow};
              text-align: center;
              border-radius: 0.48rem;
              padding: 4% 1% 4% 9%;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              .manageMetricTooltipClose {
                width: 0.704rem;
                height: 0.704rem;
                font-size: 1.05rem;
                opacity: 0.65;
                padding-left: 0.24rem;
                color: ${colors.pureBlack};
                font-weight: bold;
                margin-bottom: auto;
                margin-left: auto;
                margin-right: 5%;
              }
              .manageMetricTooltipText {
                text-align: left;
                width: 90%;
                color: black;
                font-size: 1.12rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.25;
                letter-spacing: normal;
                font-family: Arial, "sans-serif";
              }
            }
          }
        }
      }
      .save-btn {
        margin-left: auto;
        margin-right: 5%;
        color: ${colors.brillantBlue};
        letter-spacing: 0.024rem;
        background: none;
        border: none;
        &:hover,
        &:focus {
          background: none;
        }
      }
    }
  }

  .metricbody {
    grid-column: 1/13;
    grid-row: 2/13;
    background-color: ${colors.bluishGray};
    margin-top: 2%;
    overflow-y: auto;
    padding-bottom: 20px;
    overflow-x: hidden;
    .metricList {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-left: 0;
      padding-top: 2%;
      margin-top: 4%;
      list-style-type: none;
      height: 100%;
      .eachMetric {
        transition: 0.1s transform;
        margin-top: 4%;
        padding-left: 5%;
        padding-right: 5%;
        &.no-transition {
          -webkit-transition: none;
          -moz-transition: none;
          -o-transition: color 0 ease-in;
          -ms-transition: none;
          transition: none;
        }
        .parallelRow {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin-bottom: 2%;
          .eachNoteSeparator {
            height: 1px;
            background-color: ${colors.autumnFog};
            opacity: 0.3;
            margin-top: 6%;
          }
          .eachMetricRow {
            display: flex;
            justify-content: flex-start;

            .cross {
              width: 1.008rem;
              height: 1.008rem;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 10px;
            }
            .metric-info {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              margin-left: 4%;
              .metricTitle {
                width: 20rem;
                word-wrap: break-word;
                font-family: Arial, "sans-serif";
                font-size: 0.96rem;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.33;
                letter-spacing: 0.024rem;
                color: ${colors.milkyWhite};
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .metricStore {
                height: 1.28rem;
                width: 17.12rem;
                opacity: 0.5;
                font-family: Arial, "sans-serif";
                font-size: 0.88rem;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: normal;
                color: ${colors.milkyWhite};
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .slider {
              margin-left: auto;
              width: 1.072rem;
              height: 1.096rem;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 10px;
            }
          }
        }
      }
    }
  }
`;
